import useConteudoMinistradoForm
  from './hooks/use-conteudo-ministrado-form.hook';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useGlobalContext } from '../../../../../context/GlobalContext';
import useConteudoAlreadyRegistered
  from './hooks/use-conteudo-already-registered.hook';
import useFindRelatorioFrequencias
  from '../../../hooks/use-find-relatorio-frequencias.hook';
import {
  useFindConteudoAula
} from '../../../hooks/use-find-conteudo-aula.hook';
import {
  useGenericFrequenciaSkillFormHook
} from '../../../hooks/use-generic-frequencia-skill-form.hook';
import { useTranslation } from 'react-i18next';
import { listAccordionFormStore } from '../../../store/list-accordion-form.store';
import { useNotificationService } from '../../../../../services/notification.service';
import { conteudoMinistradoDataStore } from '../../../../../store/lancamento-aula/step-1/conteudo-ministrado-data.store';

export default function useLancamentoAulaStep1() {
  const { setIsGlobalLoading } = useGlobalContext();
  const [isConteudoRegistered, setIsConteudoRegistered] = useState(false);
  const hasInitialized = useRef(false);

  const { relatorioFrequencias, getRelatorioFrequencias } =
    useFindRelatorioFrequencias();
  const { getConteudoAula } = useFindConteudoAula();
  const { submitForm: submitFrequenciaSkillForm } =
    useGenericFrequenciaSkillFormHook({ isEdit: false });
  const { openFirstAccordion } = listAccordionFormStore();
  const { resetConteudoMinistradoData } = conteudoMinistradoDataStore();
  const notificationService = useNotificationService();

  const {
    checkIfConteudoExists
  } = useConteudoAlreadyRegistered();
  const { t } = useTranslation(['gestao_de_aulas']);

  const syncCreatePageData = useCallback(async () => {
    setIsGlobalLoading(true);
    resetConteudoMinistradoData();

    const conteudoExists = await checkIfConteudoExists({
      enableNavigation: false
    });

    setIsConteudoRegistered(Boolean(conteudoExists));

    const relatorio = await getRelatorioFrequencias();
    const hasPendingFrequencias = relatorio?.some((item) => !item?.hasFrequencia);

    if (conteudoExists && hasPendingFrequencias) {
      notificationService({
        type: 'warning',
        message: t('gestao_de_aulas:taughtContent'),
        description: t('gestao_de_aulas:contentAlreadyRegisteredHint')
      });
    }

    if (conteudoExists)
      openFirstAccordion();

    if (conteudoExists)
      await getConteudoAula();

    setIsGlobalLoading(false);
  }, [checkIfConteudoExists, getConteudoAula, getRelatorioFrequencias, notificationService, openFirstAccordion, resetConteudoMinistradoData, setIsGlobalLoading, t]);

  const { formObject: { submitForm } } = useConteudoMinistradoForm({
    navigateToNextStepOnSuccess: false,
    resetAfterSuccess: false,
    onSuccess: () => {
      setIsConteudoRegistered(true);
      getConteudoAula();
      getRelatorioFrequencias().then(() => openFirstAccordion());
    }
  });

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const controller = new AbortController();

    syncCreatePageData();

    return () => {
      controller.abort();
      resetConteudoMinistradoData();
    };
  }, [resetConteudoMinistradoData, syncCreatePageData]);

  return {
    formObject: {
      submitForm,
      buttonLabel: t('gestao_de_aulas:registerContent'),
      formIsDisabled: isConteudoRegistered,
      disableSubmitButton: isConteudoRegistered
    },
    relatorioFrequencias,
    isConteudoRegistered,
    form: {
      submit: submitFrequenciaSkillForm
    },
  };
}
